import moment from 'moment';
import { updloadImageState } from '../constant/index';

export const maxFileSize = 1 * 1024 * 1024;

const ImageUploaderUtil = {
  getUploadImageState: file => {
    let imageState = '';

    if (file.status === 'removed') {
      imageState = updloadImageState.REMOVED;
    } else {
      const uploadType = file.type.split('/');

      if (file.size > maxFileSize) {
        imageState = updloadImageState.FILE_SIZE_EXCEED;
      } else if (uploadType.includes('jpeg')) {
        imageState = updloadImageState.VALID;
      } else {
        imageState = updloadImageState.INVALID_TYPE;
      }
    }

    return imageState;
  },

  getFileExtByFileName: name => {
    let result = '';
    const nameSplit = name.split('.');

    if (nameSplit.length > 1) {
      const [, ext] = nameSplit;
      result = ext;
    }

    return result;
  },

  getNewFileName: fileExt => {
    let result = '';

    const dateString = moment().format('YYYYMMDD');
    const timeString = moment().format('HHmmss');
    const timeStamp = new Date().getTime();

    result = `${fileExt}_${dateString}_${timeString}_${timeStamp}.${fileExt}`;

    return result;
  },

  getNewFileObj: (originFileObj, name, extension) => {
    const options = {
      type: `image/${extension}`,
    };
    const result = new File([originFileObj], name, options);
    return result;
  },
};

export default ImageUploaderUtil;
